import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getBranchCode, getCompanyCode, getLicenseeCode } from "./GetUserInfo.js";

export const GetLink = () => {
  const licenseeCode = getLicenseeCode();
  const { CompanyCode } = getCompanyCode();
  const { BranchCode } = getBranchCode();

  let getLink = `${process.env.REACT_APP_API_URL}/graphql`;

  if (licenseeCode && CompanyCode && BranchCode) {
    getLink = `${getLink}/${licenseeCode}/${CompanyCode}/${BranchCode}`;
  }
  let defaultLink = new HttpLink({
    uri: getLink,
    credentials: "include",
  });

  const makeLink = (Licensee, Company, Branch) => {
    // console.log(Licensee, Company, Branch);
    // getLink = `${getLink}/${Licensee}/${Company}/${Branch}`;
    // console.log(getLink);
    return new HttpLink({
      uri: `${getLink}/${Licensee}/${Company}/${Branch}`,
      credentials: "include",
    });
  };

  const secondaryLink = new HttpLink({
    // uri: `https://devbackend.easemytransport.com/graphql`,
    uri: `${process.env.REACT_APP_CUSTOMER_SITE_BACKEND}/graphql`,
    credentials: "include",
  });
  const chooseLink = new ApolloLink((operation, forward) => {
    const context = operation.getContext();
    const serverHeader = context?.headers && context?.headers["X-GraphQL-Server"];

    if (serverHeader === "secondary") {
      return secondaryLink.request(operation, forward);
    }

    if (context?.internalHeaders?.Licensee) {
      const { Licensee, Company, Branch } = context?.internalHeaders;

      let link = makeLink(Licensee, Company, Branch).request(operation, forward);

      return link;
    }
    return defaultLink.request(operation, forward);
  });
  const authLink = setContext(async (_, { headers }) => {
    const token = await sessionStorage.getItem("tokenf");
    headers = headers ?? {};
    const path = window.location.pathname;
    const { Licensee, Company, Branch, ...cleanedHeaders } = headers;
    const internalHeaders = {};
    if (Licensee) internalHeaders.Licensee = Licensee;
    if (Company) internalHeaders.Company = Company;
    if (Branch) internalHeaders.Branch = Branch;
    return {
      headers: {
        ...cleanedHeaders,
        authorization: token ? `${token}` : "",
        requestUrl: path,
        usertype: headers?.usertype ? headers?.usertype : "erp",
      },
      internalHeaders: { Licensee, Company, Branch },
    };
  });

  const link = authLink.concat(chooseLink);
  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
};
